<div class="top-bar">
    <shared-address-accesscontrol-selector-component [(value)]="addressAccessControl"
        (changeValues)="onChangeAddressAccessControl($event)">
    </shared-address-accesscontrol-selector-component>
</div>
<div class="columns">
    <div class="left-column" [class.left-open]="isRightOpen">
        <shared-forklift-left [value]="value" [open]="isRightOpen" [selectedGateId]="selectedGateId"
            (clickGateOption)="onClickGateOption($event)">
        </shared-forklift-left>
    </div>
    <div class="right-column">
        <shared-forklift-right [value]="value" [open]="isRightOpen" (openChange)="isRightOpen = $event">
        </shared-forklift-right>
    </div>
</div>